import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { RealtorRequestTrapContainer } from 'shared/containers/valuationTraps';
import { selectIsAgent } from 'shared/selectors';

import { MyHomeTrapContainer } from '../MyHomeTrapContainer';

export const ValuationTrapLoader: React.FC = () => {
  const isAgent = useSelector(selectIsAgent);

  // TODO: Логика показа в https://jira.cian.tech/browse/CD-198071
  const isMyHomeTrap = false;

  if (isMyHomeTrap && !isAgent) {
    return (
      <CardSectionNew hideForPrint>
        <MyHomeTrapContainer />
      </CardSectionNew>
    );
  }

  return (
    <CardSectionNew hideForPrint withBorders>
      <RealtorRequestTrapContainer withoutBorders={true} />
    </CardSectionNew>
  );
};
